"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _text = require("@oneloop/text");
var _excluded = ["children", "variant", "titleText", "prefixIcon", "suffix", "width", "height"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var ContainerMenu = exports.ContainerMenu = function ContainerMenu(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    titleText = _ref.titleText,
    prefixIcon = _ref.prefixIcon,
    suffix = _ref.suffix,
    width = _ref.width,
    height = _ref.height,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    tx: "containerMenu",
    variant: variant,
    __css: {
      position: 'relative',
      fontFamily: 'Nunito Sans',
      display: 'flex',
      flexDirection: 'column',
      padding: '12px',
      gap: '16px',
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '10px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: prefixIcon,
    fontSize: "18px",
    style: {
      color: '#DF1E02',
      marginTop: '2px'
    }
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "bodyBold.fontSize14",
    style: {
      color: '#384248',
      marginTop: '6px'
    }
  }, titleText)), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      position: 'absolute',
      right: '13px',
      top: '12px'
    }
  }, suffix), children);
};